import { Ad } from "@dto/Ad";
import { Image } from "@ui-kit/Image/Image";
import { FunctionComponent, useCallback, useEffect, useState } from "react";
import { useInView } from "@hooks/useInView/useInView";
import { createAdClick, createAdImpression } from "@lib/analytics";
import { useDispatch } from "react-redux";
import { setLastImpression } from "@store/ad/adReducer";

import "./AdListItem.css";

interface AdListItemProps {
  ad: Ad;
}

const AdListItem: FunctionComponent<AdListItemProps> = ({ ad }) => {
  const { ref, isInView } = useInView(0.5);
  const [hasTrackedImpression, setHasTrackedImpression] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isInView && !hasTrackedImpression) {
      createAdImpression(ad.id, ad.name);
      setHasTrackedImpression(true);
      dispatch(setLastImpression(ad));
    }
  }, [isInView, hasTrackedImpression, ad.id, ad.name, dispatch, ad]);

  const handlePress = useCallback(() => {
    createAdClick(ad.id, ad.name);
  }, [ad.id, ad.name]);

  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a
      href={ad.url}
      ref={ref}
      title={ad.name}
      className="ad-list-item-component"
      target="_blank"
      onClick={handlePress}
      rel="noopener">
      <Image src={ad.imageUrl} />
    </a>
  );
};

export { AdListItem };
